import React from 'react';

interface Gate3DIconProps {
  size?: number;
  color?: string;
}

export const Gate3DIcon = ({ size = 48, color = '#0b7b41' }: Gate3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 40);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="58" rx="16" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Left pillar */}
      <rect x="8" y="14" width="10" height="42" fill={color} />
      <path d="M18 14 L22 10 L22 52 L18 56 Z" fill={darkerColor} />
      <rect x="8" y="14" width="10" height="4" fill={lighterColor} />
      {/* Right pillar */}
      <rect x="46" y="14" width="10" height="42" fill={color} />
      <path d="M56 14 L60 10 L60 52 L56 56 Z" fill={darkerColor} />
      <rect x="46" y="14" width="10" height="4" fill={lighterColor} />
      {/* Gate arch */}
      <path d="M18 14 L18 10 C18 10 24 6 32 6 C40 6 46 10 46 10 L46 14" fill={color} />
      <path d="M46 10 L50 6 C50 6 42 2 32 2 C22 2 18 6 18 6 L22 10 C22 10 26 6 32 6 C38 6 46 10 46 10 Z" fill={lighterColor} opacity="0.3" />
      {/* Gate bars */}
      <rect x="22" y="18" width="2" height="34" rx="1" fill={darkerColor} />
      <rect x="28" y="18" width="2" height="34" rx="1" fill={darkerColor} />
      <rect x="34" y="18" width="2" height="34" rx="1" fill={darkerColor} />
      <rect x="40" y="18" width="2" height="34" rx="1" fill={darkerColor} />
      {/* Digital screen on gate */}
      <rect x="24" y="22" width="16" height="10" rx="1" fill={lighterColor} />
      <rect x="25" y="23" width="14" height="8" rx="1" fill="white" opacity="0.3" />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
